module.exports = __webpack_public_path__ + "img/back-2.b0e8e0d5.png";